/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import VueI18n from 'vue-i18n'
import router from './routes/router';
import store from './store'
import VueCookie from 'vue-cookie'


import th from './languages/th'
import en from './languages/en'

import { VueReCaptcha } from 'vue-recaptcha-v3';
//Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA })
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA ,loaderOptions: {
    useRecaptchaNet: true,autoHideBadge: true
  }})



// Vue.prototype.getErrorText = function (data){
//   if (data.Msg == "errors.msw") {
//     return data.Cause;
//   }
//   return "";
// }
Vue.mixin({
  methods: {
    getErrorText: function(data) {
      // MswCause carries the raw MetaSwitch ExtendedResultDetail (issue #25).
      // Cause stays suppressed — it can hold backend-only context.
      return data?.MswCause || "";
    },
	TwoFAErrorText: function (msg,errkey) {
		let errorsCode = ["S-AUT-00000", "B-AUT-00001", "B-AUT-00002", "B-AUT-00402", "B-AUT-00403", "B-AUT-00404", "B-AUT-99999", "T-AUT-00101", "T-AUT-00102", "T-AUT-00103", "T-AUT-00405", "T-AUT-00503", "T-AUT-00901", "T-AUT-00902", "T-AUT-99999", "T-AUT-00101", "T-AUT-00102", "B-SRV-00403", "B-SRV-00404", "B-SRV-00406", "B-SRV-00410", "B-SRV-61001", "B-SRV-61002", "B-SRV-61003", "B-SRV-61004", "B-SRV-61005", "B-SRV-61006", "B-SRV-61007", "B-SRV-61009", "B-SRV-61010", "B-SRV-61011", "B-SRV-61012", "B-SRV-61013", "B-SRV-99999", "T-SRV-00101", "T-SRV-00102", "T-SRV-00103", "T-SRV-00405", "T-SRV-00503", "T-SRV-00901", "T-SRV-00902", "T-SRV-00904", "T-SRV-00905", "T-SRV-00906", "T-SRV-00907", "T-SRV-00908", "T-SRV-00909", "T-SRV-00910", "T-SRV-13001", "T-SRV-13003", "T-SRV-13004", "T-SRV-13005", "T-SRV-13006", "T-SRV-13002", "T-SRV-13000", "T-SRV-99999", "T-SRV-00101", "T-SRV-00102", "T-ESV-00401", "T-ESV-00498", "T-ESV-00502"]
		let errMsg = ""

		errorsCode.forEach(e=>{
			if (msg.includes(e)) {
				let key = "errors.twofa." + e.replaceAll("-","_")
				errMsg = this.$t(key)
				return
			}
		})

		return errMsg == "" ? this.$t(errkey) : errMsg
	},
	TwoFAErrorCode: function (msg) {
		let errorsCode = ["S-AUT-00000", "B-AUT-00001", "B-AUT-00002", "B-AUT-00402", "B-AUT-00403", "B-AUT-00404", "B-AUT-99999", "T-AUT-00101", "T-AUT-00102", "T-AUT-00103", "T-AUT-00405", "T-AUT-00503", "T-AUT-00901", "T-AUT-00902", "T-AUT-99999", "T-AUT-00101", "T-AUT-00102", "B-SRV-00403", "B-SRV-00404", "B-SRV-00406", "B-SRV-00410", "B-SRV-61001", "B-SRV-61002", "B-SRV-61003", "B-SRV-61004", "B-SRV-61005", "B-SRV-61006", "B-SRV-61007", "B-SRV-61009", "B-SRV-61010", "B-SRV-61011", "B-SRV-61012", "B-SRV-61013", "B-SRV-99999", "T-SRV-00101", "T-SRV-00102", "T-SRV-00103", "T-SRV-00405", "T-SRV-00503", "T-SRV-00901", "T-SRV-00902", "T-SRV-00904", "T-SRV-00905", "T-SRV-00906", "T-SRV-00907", "T-SRV-00908", "T-SRV-00909", "T-SRV-00910", "T-SRV-13001", "T-SRV-13003", "T-SRV-13004", "T-SRV-13005", "T-SRV-13006", "T-SRV-13002", "T-SRV-13000", "T-SRV-99999", "T-SRV-00101", "T-SRV-00102", "T-ESV-00401", "T-ESV-00498", "T-ESV-00502"]
		let errMsg = ""

		errorsCode.forEach(e=>{
			if (msg.includes(e)) {
				let key = "errors.twofa_code"
				errMsg = this.$t(key,[e])
				return
			}
		})
		return errMsg
	}
  }
});

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueCookie )


Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'th', // set locale
  messages : { en:en , th:th}, // set locale messages
})


/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  render: h => h(App),
  store,
  router
});

